import { render, staticRenderFns } from "./addComplaintList.vue?vue&type=template&id=4343b25e&scoped=true"
import script from "./addComplaintList.vue?vue&type=script&lang=js"
export * from "./addComplaintList.vue?vue&type=script&lang=js"
import style0 from "./addComplaintList.vue?vue&type=style&index=0&id=4343b25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4343b25e",
  null
  
)

export default component.exports